import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Base from './Base';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Base />
  </React.StrictMode>
);

reportWebVitals();
